const PAGE_SIZE = 20;
const PAGE_SIZE_LARGE = 100;
const nativeServices = {
  record: 1,
};
const examCreateGiftLimit = 10;
const assignmentCreateGiftLimit = 10;

export {
  PAGE_SIZE,
  PAGE_SIZE_LARGE,
  nativeServices,
  examCreateGiftLimit,
  assignmentCreateGiftLimit,
};
